import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ClickCardStoreModel } from '../click-card-models/click-card-store-model';

export const clickCardModuleStateKey = 'clickCardModuleData';

export const clickCardFeatureDetails = createFeatureSelector<ClickCardStoreModel>(clickCardModuleStateKey);
export const clickCardState = (state: ClickCardStoreModel) => state;
export const clickCardStoreModel = createSelector(clickCardFeatureDetails, clickCardState);
